// eslint-disable-next-line import/no-cycle
import QueryWhereNode from './query-where-node';
// eslint-disable-next-line import/no-cycle
import QueryWhereChildren from './query-where-children';
import QueryWhereRules, { rulesMap } from './query-where-rules';
import QueryHaving from '~/scripts/services/model/query-having';

/**
 * @param {any} c
 * @param {?QueryWhereChild} [parent]
 * @returns {QueryWhereChild}
 */
const childMap = (c, parent = null) => {
	// eslint-disable-next-line no-use-before-define
	const child = new QueryWhereChild();
	child.node = typeof c.node === 'string' ? c.node : new QueryWhereNode(c.node);
	child.having = c.having;
	if (c.children) {
		// eslint-disable-next-line no-use-before-define
		child.children = childrenMap(c.children, parent);
	}
	if (c.rules) {
		child.rules = new QueryWhereRules();
		child.rules.condition = c.rules.condition;
		for (const ri of c.rules.items) {
			const rule = rulesMap(ri, child.node, parent);
			if (rule) {
				child.rules.items.push(rule);
			}
		}
	}
	return child;
};

/**
 * @param {QueryWhereChildren} c
 * @param {?QueryWhereChild} parent
 * @returns {QueryWhereChildren}
 */
const childrenMap = (c, parent = null) => {
	const children = new QueryWhereChildren();
	children.condition = c.condition;
	children.items = c.items.map((/** @type {any} */ c2) => c2 && childMap(c2, parent));
	return children;
};

/**
 * @param {any} r
 * @param {?(QueryWhereNode | 'parent')} node
 * @param {?(QueryWhereRules | QueryWhereChild)} parent
 * @returns {QueryWhereRules}
 */
const itemsMap = (r, node = null, parent = null) => {
	const rules = new QueryWhereRules();
	rules.condition = r.condition;
	for (const ri of r.items) {
		const rule = rulesMap(ri, node, parent);
		if (rule) {
			rules.items.push(rule);
		}
	}
	return rules;
};

export default class QueryWhereChild {
	#parent;

	/**
	 * @param {any} child
	 * @param {?QueryWhereChild} parent
	 */
	constructor(child = null, parent = null) {
		this.#parent = parent;

		/** @type {?(QueryWhereNode | 'parent')} */
		const node = child?.node ? (typeof child.node === 'string' ? child.node : new QueryWhereNode(child.node)) : null;

		/** @type {?QueryWhereChildren} */
		this.children = child?.children ? childrenMap(child.children, this) : null;

		/** @type {import('./query-having').default | undefined} */
		this.having = child?.having ? new QueryHaving(child.having) : undefined;

		/** @type {?(QueryWhereNode | 'parent')} */
		this.node = node;

		/** @type {?QueryWhereRules} */
		this.rules = child?.rules ? itemsMap(child.rules, this.node, this) : null;
	}

	get parent() {
		return this.#parent;
	}

	removeRules() {
		this.rules = null;
	}
}
